import firebase from "common/Firebase";
import { TFirestoreTimestamp } from "common/types/FirebaseTypes";

export function now(): TFirestoreTimestamp {
  return dateToTimestamp(new Date());
}

export function dateToTimestamp(date: Date): TFirestoreTimestamp {
  return firebase.firestore.Timestamp.fromDate(date);
}

export function isTimestamp(value: any): boolean {
  return value instanceof firebase.firestore.Timestamp;
}

export function deleteField() {
  return firebase.firestore.FieldValue.delete();
}



// WEBPACK FOOTER //
// ./src/utils/FirebaseUtils.ts